import AskAiShortcut from "./components/AskAiShortcut.vue";
import askAiModule from "./store/askai.store";

export default {
  install(Vue, options = {}) {
    Vue.component("AskAiShortcut", AskAiShortcut);

    if (options.store) {
      options.store.registerModule("askAi", askAiModule);
    }
  },
};
